export default "__VITE_ASSET__siMAW2OG__"